// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__AA-Ou","tab":"styles_tab__7aOFP","active":"styles_active__-jyMe"};